document.addEventListener("DOMContentLoaded", () => {
  function addHandleForRecentProductsFetch() {
    /* TYNA 2026-07-28 — LGPD: histórico de navegação é dado pessoal quando
       vinculável ao cliente logado. Só grava com consentimento de analytics
       (helper em assets/cookies.js, carregado antes no layout). */
    if (typeof analyticsConsentGranted === 'function' && !analyticsConsentGranted()) return;

    const handles = localStorage.getItem("recently-viewed");
    const productHandle =
      document.querySelector(".js-product").dataset.productHandle;

    if (handles) {
      if (handles.includes(productHandle)) return;

      const handlesToAdd = [productHandle, ...handles.split(",")];

      if (handlesToAdd.length > 10) {
        handlesToAdd.pop();
      }

      localStorage.setItem("recently-viewed", handlesToAdd.join(","));

      return;
    }

    localStorage.setItem("recently-viewed", productHandle);
  }
  addHandleForRecentProductsFetch();
});
